When the signal was generated.
